import { useState, useRef, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import AuthContext from '../../store/auth-context';
import classes from './AuthForm.module.css';

import axios from 'axios';

const AuthForm = () => {
  const history = useHistory();
  const emailInputRef = useRef();
  const passwordInputRef = useRef();

  const authCtx = useContext(AuthContext);

  const [isLogin, setIsLogin] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const switchAuthModeHandler = () => {
    setIsLogin((prevState) => !prevState);
  };

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredEmail = emailInputRef.current.value;
    const enteredPassword = passwordInputRef.current.value;

    // optional: Add validation

    setIsLoading(true);
    let url;
    if (isLogin) {
      url =
        'https://api.casalindacity.com/owner/login';
    } else {
      url =
        'https://api.casalindacity.com/owner/login';
    }
    fetch(url, {
      method: 'POST',
        body: JSON.stringify({
        user: enteredEmail,
        pass: enteredPassword,
        returnSecureToken: true,
      }),
      headers: {
        'Content-Type': 'application/json',
        'Token': '3d524a53c110e4c22463b10ed32cef9d',
      },
    })
      .then((res) => {
        setIsLoading(false);
        if (res.ok) {
          //console.log(res);
          return res.json();
        } else {
          return res.json().then((data) => {
            let errorMessage = 'Authentication failed!';
            // if (data && data.error && data.error.message) {
            //   errorMessage = data.error.message;
            // }

            throw new Error(errorMessage);
          });
        }
      })
      .then((data) => {
        const expirationTime = new Date(
          new Date().getTime()  + 13500000
        );
        /*13500000 miliseconds is 15 minutes*/
        //const villas={"no": "850", "no1":730, "no2":913};

        const villasUrl='https://api.casalindacity.com/villas-lots/owner/'+data[0].id;
        
        //const villasUrl='https://api.casalindacity.com/villas-lots/owner/57';

        const apiHeader=  {
                            headers: { 'Content-Type': 'application/json', 'Token': '3d524a53c110e4c22463b10ed32cef9d'  }
                          };
         ///===============================================
            const axiosTest = axios.get

            // Axios Test Data.
            axiosTest(villasUrl,apiHeader).then(function(axiosTestResult) {
             /* console.log('response.JSON:', {
                message: 'Request received',
                data: axiosTestResult.data
              })*/
              const villita=axiosTestResult.data;
              //console.log('Datos de login: ', vill, villita[0].no);
             // console.log('Datos de villas: ', villita);
              const toquen=data[0].id;
              const expiration=expirationTime.toISOString();
              const ownerDetails=JSON.stringify(data[0]);
              const allVillas=JSON.stringify(axiosTestResult.data);
              const villaSlected=JSON.stringify(villita[0]);
              const totalQuantityVillas=villita.length;

              authCtx.login(toquen, expiration, ownerDetails, allVillas, villaSlected, totalQuantityVillas);
            })

         ///==================================

       
        history.replace('/');
        //console.log(JSON.stringify(data[0]));
      })
      .catch((err) => {
        alert(err.message);
        console.log(err.message);
      });
  };

  return (
    <section className={classes.auth}>
      <h1>{isLogin ? 'Login' : 'Sign Up'}</h1>
      <form onSubmit={submitHandler}>
        <div className={classes.control}>
          <label htmlFor='email'>Your Email</label>
          <input type='email' id='email' required ref={emailInputRef} />
        </div>
        <div className={classes.control}>
          <label htmlFor='password'>Your Password</label>
          <input
            type='password'
            id='password'
            required
            ref={passwordInputRef}
          />
        </div>
        <div className={classes.actions}>
          {!isLoading && (
            <button>{isLogin ? 'Login' : 'Create Account'}</button>
          )}
          {isLoading && <p>Sending request...</p>}
          <button
            type='button'
            className={classes.toggle}
            onClick={switchAuthModeHandler}
          >
            {/*isLogin ? 'Create new account' : 'Login with existing account'*/}
          </button>
        </div>
      </form>
    </section>
  );
};

export default AuthForm;
